export default "__VITE_ASSET__BgWs3O2V__"